import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import reactT from '../../components/reactT';
import FederatedSolrComponentPack from "../federated_solr_component_pack";
// Renders plain text input and submit button for text search.
// Rendered when env config autocomplete is not present or set to false.
// @see /env.local.js.example
class FederatedTextSearchNoAutocomplete extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputKeyDown = this.handleInputKeyDown.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.uniqueId = `search-keywords-${Math.random().toString(36).substring(7)}`;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.value,
    });
  }

  handleInputChange(ev) {
    this.setState({
      value: ev.target.value.trimStart(),
    });

    if (this.state.value.trimStart() === '') {
      ev.target.parentElement.querySelector('.form-actions button').click();
    }
  }

  handleInputKeyDown(ev) {
    if (ev.keyCode === 13) {
      this.handleSubmit();
    }
  }

  handleSubmit() {
    let minLength = 3;
    if (this.state.value !== '') {
      const hasKorean = /[\uAC00-\uD7AF\u1100-\u11FF\u3130-\u318F]/.test(this.state.value);

      // Set minlength dynamically
      if (hasKorean) {
        minLength = 1;
      }

      if (this.state.value.length >= minLength) {
        this.props.onChange(this.props.field, this.state.value);
        // Get existing querystring params.
        const parsed = queryString.parse(window.location.search);
        // Update the search querystring param with the value from the search field.
        parsed.keywords = this.state.value.trim();
        const stringified = queryString.stringify(parsed);
        // Update the querystring params in the browser, add path to history.
        // See: https://developer.mozilla.org/en-US/docs/Web/API/History_API#The_pushState()_method
        if (window.history.pushState) {
          const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${stringified}`;
          window.history.pushState({path: newUrl}, '', newUrl);
        } else {
          window.location.search = stringified;
        }
      }
    }
  }

  render() {
    const {
      label,
      customComponents,
      bootstrapCss,
      query,
      results,
      onPageChange,
    } = this.props;
    const { searchFields, rows } = query;
    const start = query.start ? query.start : 0;
    const ResultCount = customComponents.results.resultCount;
    const hasKorean = this.state.value && /[\uAC00-\uD7AF\u1100-\u11FF\u3130-\u318F]/.test(this.state.value);
    const minLength = hasKorean ? 1 : 3;

    return (
      <React.Fragment>
        <label htmlFor="search" className="search-form__label">{label}</label>
        <div className="form-item-keywords">
          <label htmlFor={this.uniqueId} className="visually-hidden">Keywords:</label>
          <input
            type="text"
            name="search-keywords"
            id={this.uniqueId}
            className="form-control"
            autoFocus
            onChange={this.handleInputChange}
            onKeyDown={this.handleInputKeyDown}
            value={this.state.value || ''}
            required='required'
            minLength={minLength}
          />
          <ResultCount
            bootstrapCss={bootstrapCss}
            numFound={results.numFound}
            start={start}
            rows={rows}
            onChange={onPageChange}
            noResultsText={this.props.options.noResults || null}
            termValue={
              searchFields.find((sf) => sf.id === "textSearchField").value
            }
            className ='d-md-none'
          />
          <a className="search-tips-btn" href="!#" onClick={(e) => e.preventDefault()} data-toggle="modal" data-target="#searchTips">{reactT('Search tips')}</a>
          <div className="form-actions">
            <button
              type="submit"
              className="button js-form-submit form-submit btn btn-primary"
              onClick={this.handleSubmit}>
              <span className="element-invisible">Perform Search</span>
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

FederatedTextSearchNoAutocomplete.defaultProps = {
  bootstrapCss: true,
  customComponents: FederatedSolrComponentPack,
  label: '',
  onChange: () => {},
  value: '',
  searchFields: [
    {
      type: "text",
      field: "*",
    },
  ],
};

FederatedTextSearchNoAutocomplete.propTypes = {
  field: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  bootstrapCss: PropTypes.bool,
  customComponents: PropTypes.object,
  results: PropTypes.object,
  query: PropTypes.object,
};

export default FederatedTextSearchNoAutocomplete;
